import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { Invite } from '@/types/user';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

export const getInvites = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<Invite[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<Invite[]>>('/organization/invite', options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
